"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Observer2 = require("./Observer");

var _Observer3 = _interopRequireDefault(_Observer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TraversedZonesModel = function (_Observer) {
    _inherits(TraversedZonesModel, _Observer);

    function TraversedZonesModel(observers, id, request) {
        _classCallCheck(this, TraversedZonesModel);

        var _this = _possibleConstructorReturn(this, (TraversedZonesModel.__proto__ || Object.getPrototypeOf(TraversedZonesModel)).call(this, observers, id, request));

        _this.TraversedZones = [];
        return _this;
    }
    /**
     * Liste von durchfahrenen Zonen
     * @type {array}
     */


    return TraversedZonesModel;
}(_Observer3.default);

exports.default = TraversedZonesModel;